module.exports = __webpack_public_path__ + "img/im-not-dying-with-you-tonight.f977cca8.png";